<template>
  <div class="search">
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="textToSearch"
          class="ma-0 pa-0 search-input"
          prepend-inner-icon="mdi-magnify"
          :placeholder="$t('search.txt.placeholder')"
          single-line
          full-width
          hide-details
          dense
          color="slate"
        />
      </v-col>
      <v-col
        class="text-sm-right align-self-end"
        cols="12"
        sm="6"
      >
        <span class="sort-label">{{ $t('search.txt.sort_by') }}</span>
        <v-select
          v-if="sortItems[0] && sortItems[0].text"
          class="d-inline-flex sort-items"
          background-color="pale-three"
          color="slate"
          :append-icon="'mdi-chevron-down'"
          :items="sortItems"
          :menu-props="{ offsetY: true }"
          dense
          filled
          rounded
          return-object
          @change="sortByItem"
        />
        <div class="d-none d-lg-inline-flex ml-7">
          <v-btn
            class="view-btn mr-5"
            :class="{ active: viewType === 'grid' }"
            icon
            color="cloudy"
            width="18px"
            @click="changeView('grid')"
          >
            <v-icon>mdi-view-grid</v-icon>
          </v-btn>
          <v-btn
            class="view-btn"
            :class="{ active: viewType === 'list' }"
            icon
            color="cloudy"
            width="18px"
            @click="changeView('list')"
          >
            <v-icon>mdi-view-sequential</v-icon>
          </v-btn>
        </div>
      </v-col>
      <v-col
        class="search_filter py-0"
        cols="12"
      >
        <v-icon color="cloudy">
          mdi-filter
        </v-icon>
        <v-chip
          v-for="(item, index) in filteredProducts"
          :key="item.text"
          close
          close-icon="mdi-close"
          color="cloudy"
          text-color="slate"
          class="chip-filter"
          center
          @click:close="filteredProducts.splice(index, 1)"
        >
          {{ item.name }}
        </v-chip>
        <v-menu
          close-on-content-click
          offset-x
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn
              text
              color="peacock"
              class="add-filter"
              v-on="on"
            >
              + {{ $t('search.txt.add_filter') }}
            </v-btn>
          </template>
          <v-card>
            <v-list
              dense
              rounded
            >
              <template v-for="(item, index) in normalizedProducts">
                <v-list-item
                  v-if="!filteredProducts.includes(item)"
                  :key="index"
                  @click="filteredProducts.push(item)"
                >
                  <v-list-item-title v-text="item.name" />
                </v-list-item>
              </template>
            </v-list>
          </v-card>
        </v-menu>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'VehiclesSearch',

  props: {
    products: {
      type: Array,
      required: true
    },

    productsPrismic: {
      type: Array,
      required: true
    },
    accountRelations: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      filteredProducts: [],
      textToSearch: '',
      sortBy: 'licensePlate',
      viewType: 'list'
    }
  },

  computed: {
    normalizedProducts() {
      return this.products
        .filter(p =>
          p.productRatePlans.some(rp => rp.isAllowedToSubscribe__c == 'True')
        )
        .map(p => {
          const productPrismic = this.productsPrismic.find(catalogProduct =>
            catalogProduct.externalKey.includes(p.sku)
          )
          return {
            ...p,
            externalKey: (productPrismic && productPrismic.externalKey) || '',
            name: (productPrismic && productPrismic.title) || p.name
          }
        })
    },

    sortItems() {
      return [
        { key: 'licensePlate', text: this.$t('search.txt.license_plate') },
        { key: 'vinNumber', text: this.$t('search.txt.vin_number') },
        { key: 'ownerName', text: 'Owner' }
      ]
    }
  },

  watch: {
    textToSearch() {
      this.$emit('textToSearch', this.textToSearch)
    },

    filteredProducts: {
      handler: function(val) {
        const filteredProductsKey = val.map(item => item.externalKey)
        this.$emit('productsFilter', filteredProductsKey)
      },
      deep: true
    }
  },

  async created() {
    this.$emit('sortBy', this.sortBy)
  },

  methods: {
    sortByItem(item) {
      this.sortBy = item
      this.$emit('sortBy', this.sortBy)
    },

    changeView(view) {
      this.viewType = view
      this.$emit('viewType', this.viewType)
    }
  }
}
</script>

<style lang="scss">
.search {
  &-input {
    .v-input {
      &__slot {
        &:before {
          border-color: var(--v-cloudy-base) !important;
        }

        .v-icon {
          margin-top: 0 !important;
          color: var(--v-cloudy-base);
        }
      }
    }
  }

  .sort-label {
    font-size: 0.875rem;
    font-weight: bold;
    text-align: right;
    color: var(--v-slate-base);
    margin-right: 8px;
  }

  .sort-items {
    max-width: 200px;
    height: 32px;
    font-size: 0.875rem;

    .v-input {
      &__slot {
        min-height: 32px !important;
      }

      &__append-inner {
        margin-top: 0 !important;
      }
    }
  }

  .view-btn {
    &.active {
      i {
        color: var(--v-peacock-base);
      }
    }
  }

  &_filter {
    .chip-filter {
      font-size: 0.75rem;
      margin-left: 16px;
      text-transform: uppercase;
      font-weight: bold;
      padding: 0 16px;
    }

    .add-filter {
      font-weight: bold;
      letter-spacing: normal;
      font-size: 0.8125rem;
    }
  }
}
</style>
